export default __webpack_public_path__ + "static/media/Pool-Lounge.68bb9626.webp";